<template>
    <div>
        <div class="top-Lv1">
            <span class="tittle-lv1">编辑成员信息</span>
        </div>
        <div class="mainContent">
            <div class="mainNav">
                <Button type="primary" size="small" @click="handleSubmit('formValidate')">保存</Button>
                <Button type="ghost" size="small" @click="$router.go(-1)">取消</Button>
            </div>
            <div class="froms">
                <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="110">
                    <Row class="rows">
                        <Col span="12">
                        <FormItem label="姓名 :" prop="fullname">
                            <Input size="small" width="60" v-model="formValidate.fullname" placeholder="请填写名字"></Input>
                        </FormItem>
                        <FormItem label="性别 :" prop="sex">
                            <RadioGroup v-model="formValidate.sex">
                                <Radio label="1">男</Radio>
                                <Radio label="2">女</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="座机 :">
                            <Input size="small" v-model="formValidate.tel" placeholder=""></Input>
                        </FormItem>
                        <FormItem label="邮箱 :">
                            <Input size="small" v-model="formValidate.email" placeholder=""></Input>
                        </FormItem>
                        </Col>
                    </Row>

                    <Row v-if="depShow" class="rows">
                        <Col span="12">
                        <FormItem label="部门 :" prop="department">
                            <Cascader :data="data1" v-model="formValidate.department" change-on-select class="iv-down"></Cascader>
                        </FormItem>
                        <FormItem label="是否为主管 :" prop="single">
                            <RadioGroup v-model="formValidate.single">
                                <Radio label="1">主管</Radio>
                                <Radio label="2">专员</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="职务 :" prop="duty">
                            <Input v-model="formValidate.duty" placeholder="请输入职务名称"></Input>
                        </FormItem>
                        <FormItem>
                            <div v-if="moreShow"  @click="addDuty" style="color: #3399ff;cursor:pointer;">
                                <Icon type="plus-circled" style="font-size: 15px;"></Icon><div style="display:inline-block;margin-left: 10px">更多职务</div>
                            </div>
                        </FormItem>
                        </Col>
                    </Row>
                    <!--部门1-->
                    <Row class="rows" v-if="depShow1">
                        <div style="position: absolute;right: 10px;color: #ed3f14;cursor:pointer;" @click="delDep1">
                            <!--<Icon style="font-size: 24px;cursor:pointer;" type="ios-close-outline"></Icon>-->
                            删除
                        </div>
                        <Col span="12">
                        <FormItem label="部门1 :">
                            <Cascader :data="data1" v-model="formValidate.department1" change-on-select class="iv-down"></Cascader>
                        </FormItem>
                        <FormItem label="是否为主管 :">
                            <RadioGroup v-model="formValidate.single1">
                                <Radio label="1">主管</Radio>
                                <Radio label="2">专员</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="职务1 :">
                            <Input v-model="formValidate.duty1" placeholder="请输入职务名称"></Input>
                        </FormItem>
                        <FormItem  v-if="moreShow1" style="color: #3399ff;cursor:pointer;border-top: 1px dotted #dddee1;">
                            <div  @click="addDuty1">
                                <Icon type="plus-circled" style="font-size: 15px;"></Icon><div style="display:inline-block;margin-left: 10px">更多职务</div>
                            </div>                        </FormItem>
                        </Col>
                    </Row>
                    <!--部门2-->
                    <Row class="rows" v-if="depShow2">
                        <div style="position: absolute;right: 10px;color: #ed3f14;cursor:pointer;" @click="delDep2">
                            <!--<Icon style="font-size: 24px;cursor:pointer;" type="ios-close-outline"></Icon>-->
                            删除
                        </div>
                        <Col span="12">
                        <FormItem label="部门2 :">
                            <Cascader :data="data1" v-model="formValidate.department2" change-on-select  class="iv-down"></Cascader>
                        </FormItem>
                        <FormItem label="是否为主管 :">
                            <RadioGroup v-model="formValidate.single2">
                                <Radio label="1">主管</Radio>
                                <Radio label="2">专员</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="职务2 :">
                            <Input v-model="formValidate.duty2" placeholder="请输入职务名称"></Input>
                        </FormItem>
                        <FormItem v-if="moreShow2" style="color: #3399ff;cursor:pointer;border-top: 1px dotted #dddee1;">
                            <div  @click="addDuty2">
                                <Icon type="plus-circled" style="font-size: 15px;"></Icon><div style="display:inline-block;margin-left: 10px">更多职务</div>
                            </div>                        </FormItem>
                        </Col>
                    </Row>
                    <!--部门3-->
                    <Row class="rows" v-if="depShow3">
                        <div style="position: absolute;right: 10px;color: #ed3f14;cursor:pointer;" @click="delDep3">
                            <!--<Icon style="font-size: 24px;cursor:pointer;" type="ios-close-outline"></Icon>-->
                            删除
                        </div>
                        <Col span="12">
                        <FormItem label="部门3 :">
                            <Cascader :data="data1" v-model="formValidate.department3"  change-on-select class="iv-down"></Cascader>
                        </FormItem>
                        <FormItem label="是否为主管 :">
                            <RadioGroup v-model="formValidate.single3">
                                <Radio label="1">主管</Radio>
                                <Radio label="2">专员</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="职务3 :">
                            <Input v-model="formValidate.duty3" placeholder="请输入职务名称"></Input>
                        </FormItem>
                        <FormItem v-if="moreShow3" style="color: #3399ff;cursor:pointer;">
                            <div  @click="addDuty3" >
                                <Icon type="plus-circled" style="font-size: 15px;"></Icon><div style="display:inline-block;margin-left: 10px">更多职务</div>
                            </div>                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div class="mainNav">
                <Button type="primary" size="small" @click="handleSubmit('formValidate')">保存</Button>
                <Button type="ghost" size="small" @click="$router.go(-1)">取消</Button>
            </div>
        </div>
    </div>
</template>

<script>
    import ruleValidate from '../../validator'
    export default {
        name: 'memberChange',
        data() {
            return {
                moreShow3:false,
                moreShow2:false,
                moreShow1:false,
                moreShow:true,
                depShow:true,
                depShow1:false,
                depShow2:false,
                depShow3:false,
                value2:[],
                data1: [],
                result: [],
                dep:'',
                dutyShow:false,
                disabledSingle:'',
                formValidate: {
                    fullname: '',
                    uNum: '',
                    email: '',
                    sex: '',
                    mobile: '',
                    tel: '',
                    department: [],
                    duty: '',
                    single:'2',
                    department1: [],
                    duty1: '',
                    single1:'2',
                    department2: [],
                    duty2: '',
                    single2:'2',
                    department3: [],
                    duty3: '',
                    single3:'2',
                },
                id: ''
            }
        },
        computed:{
            ruleValidate:function () {
                return ruleValidate
            }
        },
        mounted() {
            this.id = this.$route.query.id;
            this.userDetail();
        },
        methods: {

            toAdd() {
                this.$router.push('memberAdd')
            },

            //获取用户详情
            userDetail() {
                this.$http.post(this.$api.WEB_SHOW,{id:this.id}).then(res=>{
                    if(res.data.status === '1'){
                        var userInfo = res.data.data;
                        this.formValidate.fullname = userInfo.fullname;
                        this.formValidate.email = userInfo.email;
                        this.formValidate.mobile = userInfo.mobile;
                        this.formValidate.tel = userInfo.tel;
                        this.formValidate.sex = userInfo.sex;
                        this.dep = userInfo.department;
//                        this.formValidate.gender = userInfo.sex;
                        this.department();
                        if(this.dep.length === 2){
                            this.depShow = true;
                            this.moreShow = false;
                            this.depShow1 = true;
                            this.moreShow1 = true;
                        }else if(this.dep.length === 3){
                            this.depShow = true;
                            this.moreShow = false;
                            this.depShow1 = true;
                            this.moreShow1 = false;
                            this.depShow2 = true;
                            this.moreShow2 = true;
                        }else if(this.dep.length === 4){
                            this.depShow = true;
                            this.moreShow = false;
                            this.depShow1 = true;
                            this.moreShow1 = false;
                            this.depShow2 = true;
                            this.moreShow2 = false;
                            this.depShow3 = true;
                            this.moreShow3 = false;
                        }else{
                            this.depShow = true;
                            this.moreShow = true;
                        }
                    }else{
                        this.$Message.error(res.data.msg);
                    }
                },err=>{
                    this.$Message.error('网络错误');
                })
            },

            //请求部门信息
            department() {
                this.$http.post(this.$api.DEPARTMENT_LIST,{
                    com_id:this.$store.getters.userInfo.com_id
                }).then(res => {
                    if(res.data.status === '1'){
                        this.data1 =  res.data.data;
                        this.result =  res.data.result;
                        this.departments();
                    }else{
                        this.$Message.error('网络错误');
                    }
                }, err => {
                    this.$Message.error('网络错误');
                })
            },

            //处理部门数据信息
            departments(){
                if(this.dep.length > 0){
                    for(var i=0; i<this.dep.length; i++)
                    {
                        var dep = [];
                        if(this.dep[i].dep_id.length > 0){
                            this.dep[i].dep_id.forEach(res=>{
                                dep.push(Number(res));
                            })
                        }
                        if(i === 0){
                            this.formValidate.department = dep;
                            this.formValidate.duty = this.dep[i].duty;
                            this.formValidate.single = this.dep[i].director;
                        }else if (i === 1){
                            this.formValidate.department1 = dep;
                            this.formValidate.duty1 = this.dep[i].duty;
                            this.formValidate.single1 = this.dep[i].director;
                        }else if (i === 2){
                            this.formValidate.department2 = dep;
                            this.formValidate.duty2 = this.dep[i].duty;
                            this.formValidate.single2 = this.dep[i].director;
                        }else if (i === 3){
                            this.formValidate.department3 = dep;
                            this.formValidate.duty3 = this.dep[i].duty;
                            this.formValidate.single3 = this.dep[i].director;
                        }
                    }
                }

            },

            //编辑成员信息
            handleSubmit(name) {
                var arr = [];
                var result = {};
                result.director = this.formValidate.single;
                result.duty = this.formValidate.duty;
                result.dep = this.formValidate.department[this.formValidate.department.length - 1];
                arr.push(result);
                if(this.formValidate.department1.length > 0){
                    var result = {};
                    result.dep = this.formValidate.department1[this.formValidate.department1.length - 1];
                    result.duty = this.formValidate.duty1;
                    result.director = this.formValidate.single1;
                    arr.push(result);
                }
                if(this.formValidate.department2.length > 0){
                    var result = {};
                    result.dep = this.formValidate.department2[this.formValidate.department2.length - 1];
                    result.duty = this.formValidate.duty2;
                    result.director = this.formValidate.single2;
                    arr.push(result);
                }
                if(this.formValidate.department3.length > 0){
                    var result = {};
                    result.dep = this.formValidate.department3[this.formValidate.department3.length - 1];
                    result.duty = this.formValidate.duty3;
                    result.director = this.formValidate.single3;
                    arr.push(result);
                }
                let reqData = {
                    id: this.id,
                    fullname: this.formValidate.fullname,
                    sex: this.formValidate.sex,
                    tel: this.formValidate.tel,
                    uid:this.$store.getters.userInfo.id,
                    email: this.formValidate.email,
                    department: arr,
                };
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.$http.post(this.$api.UPDATE_USER, reqData).then(res => {
                            this.$Message.info(res.data.msg);
                            this.$router.push({path: 'member', query: {page:this.$route.query.page}})
                        }, err => {
                            this.$Message.error('网络错误');
                        });
                    } else {
                        this.$Message.error('请您检查重要信息是否填写完成!');
                    }
                })
            },

            //添加更多职务
            addDuty(){
                this.depShow = true;
                this.moreShow = false;
                this.depShow1 = true;
                this.moreShow1 = true;
            },

            //添加更多职务
            addDuty1(){
                this.depShow = true;
                this.moreShow = false;
                this.depShow1 = true;
                this.moreShow1 = false;
                this.depShow2 = true;
                this.moreShow2 = true;
            },

            //添加更多职务
            addDuty2(){
                this.depShow = true;
                this.moreShow = false;
                this.depShow1 = true;
                this.moreShow1 = false;
                this.depShow2 = true;
                this.moreShow2 = false;
                this.depShow3 = true;
                this.moreShow3 = false;
            },

            //删除新增模板
            delDep1(){
                this.depShow1 = false;
                this.moreShow1 = false;
                this.formValidate.department1 = [];
                if(this.depShow2 && !this.depShow3){
                    this.moreShow2 = true;
                }else if(!this.depShow2 && !this.depShow3){
                    this.moreShow = true;
                }
            },

            //删除新增模板
            delDep2(){
                this.depShow2 = false;
                this.moreShow2 = false;
                this.formValidate.department2 = [];
                if(this.depShow1 && !this.depShow3){
                    this.moreShow1 = true;
                }else if(!this.depShow1 && !this.depShow3){
                    this.moreShow = true;
                }
            },

            //删除新增模板
            delDep3(){
                this.depShow3 = false;
                this.moreShow3 = false;
                this.formValidate.department3 = [];
                if(this.depShow1 && !this.depShow1){
                    this.moreShow1 = true;
                }else if(this.depShow1 && this.depShow2){
                    this.moreShow2 = true;
                }else if(!this.depShow1 && !this.depShow2){
                    this.moreShow = true;
                }
            }
        },
        watch:{
            'formValidate.department':function (val) {
              console.log(val);
            },
            'formValidate.duty':function (val) {
                if(val){
                    this.dutyShow = true;
                }else{
                    this.dutyShow = false;
                }
            }
        }
    }
</script>

<style scoped>
    .mainNav button {
        background-color: #fff;
    }

    .mainNav button:first-child {
        background-color: #2d8cf0;
    }

    .mainNav .adds:hover {
        opacity: 0.8;
    }

    .froms {
        padding: 8px 13px;
    }

    .photos {
        position: absolute;
        top: -22px;
        left: 0;
        width: 60px;
        height: 60px;
        line-height: 60px;
        border-radius: 30px;
        font-size: 40px;
    }

    .rows {
        padding: 20px 0;
        border-bottom: 1px solid #E4E6E9;
    }

    .ivu-form-item {
        margin-bottom: 2px;
    }

    .modelBox {
        padding: 4px 14px;
    }

    .memberList {
        height: 367px;
        margin-top: 20px;
    }

    .memberList li {
        height: 28px;
        padding-left: 28px;
        line-height: 28px;
    }

    .memberList li i {
        font-size: 16px;
        line-height: 27px;
        vertical-align: top;
    }

    .memberList li i:first-child {
        margin-right: 3px;
        color: #2d8cf0;
    }

    .memberList li i:last-of-type {
        margin-left: 10px;
        color: #ccc;
        font-size: 12px;
    }

    .xuanZe {
        margin-left: 20px;
        padding-left: 20px;
        border-left: 1px solid #E4E6E9;
        height: 407px;
    }

    .xuanZe span {
        display: block;
        font-size: 14px;
        color: #787878;
        margin-bottom: 10px;
    }

    .menberType {
        border: 1px solid #E4E6E9;
        display: inline-block;
        height: 26px;
        line-height: 26px;
        padding: 0 10px;
    }

    .menberType i:first-child {
        margin-right: 3px;
        color: #2d8cf0;
    }

    .menberType i:last-child {
        margin-left: 20px;
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/components/member/memberChange.vue